import { render, staticRenderFns } from "./InputCelular.vue?vue&type=template&id=627c8ee2&"
import script from "./InputCelular.vue?vue&type=script&lang=js&"
export * from "./InputCelular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports